<div class="inner-content">
	<ion-datetime
		mode="md"
		[hourCycle]="hourCycleType"
		[value]="date"
		[presentation]="presentationType"
		(ionChange)="handleDate($event)"
	>
		<ion-buttons slot="buttons">
			<ion-button
				data-cy="cancelButton"
				item-start
				class="cancel-button ion-no-padding ion-no-margin"
				expand="block"
				(click)="cancelModal()"
				fill="clear"
				size="large"
			>
				{{ 'datePicker.clear' | translate }}
			</ion-button>
			<ion-button
				data-cy="saveButton"
				item-end
				class="save-button ion-no-margin"
				expand="block"
				(click)="confirm()"
				fill="solid"
				size="large"
			>
				{{ 'datePicker.done' | translate }}
			</ion-button>
		</ion-buttons>
	</ion-datetime>
</div>
